import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';
// import p1 from 'assests/Photos/Clubs/LitreryClub/2023/HindiCCA/1.jpg';
// import p2 from 'assests/Photos/Clubs/LitreryClub/2023/HindiCCA/2.jpg';
// import p3 from 'assests/Photos/Clubs/LitreryClub/2023/HindiCCA/3.jpg';
// import p4 from 'assests/Photos/Clubs/LitreryClub/2023/HindiCCA/4.jpg';


import { Typography } from '@mui/material';
import Container from 'components/Container';
import { Sidebar2023 } from 'views/Literaryclub2023/components';
import { LiterarySidebar } from 'views/Literaryclub2023/components';

const HindiCCA2023 = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });


    const [config, setConfig] = useState({ base_image_archive_url: '' });
    useEffect(() => {
      fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
        .then(response => response.json())
        .then(data => setConfig(data))
        .catch(error => console.error('Error fetching config:', error));
    }, []);
    
    const p1 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/association/LitreryClub/HindiCCA/1.webp`;
    const p2 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/association/LitreryClub/HindiCCA/2.webp`;
    const p3 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/association/LitreryClub/HindiCCA/3.webp`;
    const p4 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/association/LitreryClub/HindiCCA/4.webp`;
    const photos = [
        {
            src: p1,
            source: p1,
            rows: 1,
            cols: 1,
  },    
                {
                    src: p3,
                    source: p3,
                    rows: 1,
                    cols: 1,
                },
                {
                    src: p4,
                    source: p4,
                    rows: 1,
                    cols: 2,
                },
                {
                    src: p2,
                    source: p2,
                    rows: 1,
                    cols: 2,
          },
           
          
    ];

    return (
        <Main>

            <Container>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            <Box paddingX={{ xs: 0, sm: 4, md: 6 }}>
                            <Typography variant='h5' align='center' >
                            HINDI CCA   
                                </Typography>
                                <Typography variant='h7' align='justify' >
                                Class 3: Poem Recitation (Humorous)  
                                <br />
                                Class 4: Story Telling (Moral)
                                <br />
                                Class 5: Conversation (Joint Family) 
                                </Typography>
                              
                                <Typography
                                    fontSize="x-small"
                                ><br /><br />
                                    Class: 3 to 5       Date:  January 2024
                                </Typography>
                                {/* <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                              ><br />
                                "In our Pre-Primary classrooms, storytelling is not just a fun activity; it is a creative journey where young minds explore the wonders of imagination."
                                <br />
                               </Typography> */}
                               <br />
                                <Typography variant={'subtitle1'} align={'justify'}>
                                The Hindi CCA, conducted in the first week of January saw an active and enthusiastic participation by the students of Classes 3 to 5.
                                <br />
                                The students of Classes 3 recited humorous poems fluently with proper rhythm and intonation. The students of Class 4 narrated moral Panchatantra stories beautifully. The essence of the moral was relevant to present day as well. The students of Class 5 developed meaningful dialogues in the form of Conversations pertaining to the joint family system of our country. These activities provided a platform for all the participants to showcase their innate talent in oratory skills.  
                                <br />
                                The goal was to encourage love for literature, cultural understanding and responsibility towards the community. All the students participated enthusiastically and portrayed immense talent coupled with confidence.
                                <br /> 

                                <div 
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                                className="Segoe UI">
      <p style={{ fontFamily: 'Segoe UI' }}> <strong>Tiny voices, Mighty imaginations!</strong></p>
    </div>

                                </Typography>
                                {/* <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                              ><br />
                                "Sparkling Smiles and Boundless surprise!"
                                <br />
                            </Typography> */}
                            </Box>
                            
                            <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 300 : 500}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>

                    <Grid item xs={12} md={4}>

                        <Box marginBottom={4}>
                                    <Sidebar2023/>
                        </Box>
                        <Box marginBottom={4}>
                            <LiterarySidebar/>
                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </Main>


    );
};

export default HindiCCA2023;